var map = {
	"./countries.js": "54e1",
	"./districts.js": "88de",
	"./layout.js": "c21a",
	"./news.js": "352a",
	"./packages.js": "ef3f",
	"./permissions.js": "f604",
	"./pocketmoney.js": "a8ea",
	"./profiles.js": "62e6",
	"./stores.js": "0d56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";